import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import ClearIcon from '@material-ui/icons/Clear'
import DazzedParagraph16 from '../../../common/text/DazzedParagraph16'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import IconAndText from 'components/common/IconAndText'
import Copy from 'components/common/icons/CopySmall'
import Tooltip from 'components/common/Tooltip'

export const useStyles = makeStyles({
  featureContainer: {
    marginBottom: 15,
    borderBottom: '1px solid var(--border-color-7)'
  },
  featureSubContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
    paddingLeft: 15,
    borderLeft: '2px solid var(--border-color-1)'
  },
  featureText: {
    fontWeight: 500
  },
  featureIconContainer: {
    position: 'relative',
    left: 10
  },
  featureIcon: {
    color: 'var(--border-color-1)'
  }
})

const ENABLE_FEATURE = 'ENABLE_FEATURE'
const DISABLE_FEATURE = 'DISABLE_FEATURE'

const FeatureItem = ({ feature, action, onClick, disabled = false }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleCopyId = () => {
    navigator.clipboard.writeText(feature.key)
  }

  return (
    <div key={feature.key} className={classes.featureContainer}>
      <div className={classes.featureSubContainer}>
        <div>
          <Tooltip
            value={t('dialogs.doctorCardEditor.permissions', { permissions: feature.availableFor.join(', ') })}
            placement="bottom"
          >
            <DazzedParagraph16 className={classes.featureText}>{feature.label}</DazzedParagraph16>
          </Tooltip>
          <IconAndText
            reverse
            icon={
              <Tooltip value={t('general.copy')} placement="bottom">
                <IconButton size="small" onClick={handleCopyId}>
                  <Copy />
                </IconButton>
              </Tooltip>
            }
            text={
              <DazzedParagraph14 color="var(--text-color-14)" strong>
                {t('dialogs.doctorCardEditor.id', { id: feature.key })}
              </DazzedParagraph14>
            }
          />
        </div>
        {!disabled && (
          <IconButton className={classes.featureIconContainer} onClick={() => onClick(feature, action)}>
            {action === ENABLE_FEATURE && <AddIcon className={classes.featureIcon} />}
            {action === DISABLE_FEATURE && <ClearIcon className={classes.featureIcon} />}
          </IconButton>
        )}
      </div>
    </div>
  )
}

export default FeatureItem
